
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1">
        <div className="container max-w-4xl mx-auto py-12 px-4">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="prose prose-gray max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p>By accessing and using Airfryer.ai, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Recipe Conversion Disclaimer</h2>
              <p>The recipe conversion service provided by Airfryer.ai is for informational purposes only. We do not guarantee:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>The accuracy of converted recipes</li>
                <li>The safety of converted cooking times and temperatures</li>
                <li>The final results of any recipe conversion</li>
              </ul>
              <p className="mt-2">Users should always exercise caution and judgment when following converted recipes.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. User Responsibilities</h2>
              <p>When using our service, you are responsible for:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Ensuring food safety in your cooking process</li>
                <li>Verifying cooking temperatures and times</li>
                <li>Following proper food handling guidelines</li>
                <li>Using your air fryer according to manufacturer instructions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Limitation of Liability</h2>
              <p>Airfryer.ai and its operators shall not be liable for:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Any food safety issues arising from using converted recipes</li>
                <li>Damage to cooking equipment</li>
                <li>Personal injury or property damage</li>
                <li>Any direct, indirect, incidental, or consequential damages</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. User Content</h2>
              <p>By submitting recipes or content to Airfryer.ai, you:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Grant us permission to use and modify the content</li>
                <li>Confirm you have the right to share the content</li>
                <li>Accept responsibility for the content you submit</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of new terms.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Contact</h2>
              <p>For questions about these terms, please contact us at petterijenssen@gmail.com</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
